module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModelListPage', {
    attrs: {
      "lower-app-name": "emarket",
      "lower-model-name": "order",
      "version": "2",
      "title": "订单列表"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5272c938"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/OrderList.vue
// module id = 376
// module chunks = 1